import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule, NgClass} from '@angular/common';

@Component({
  selector: 'app-grouping-tabs',
  standalone: true,
  imports: [CommonModule, NgClass],
  styles: [
    `
      @import 'tailwindcss' prefix(ipe);
      @theme {
        --font-display: 'ABC Walter Neue', sans-serif;
        --font-roboto: 'ABC Walter Neue', sans-serif;
        --font-sans: 'ABC Walter Neue', sans-serif;
      }
    `
  ],
  template: `
    <div class="ipe:flex ipe:items-center ipe:gap-8 ipe:border-b ipe:border-[#ede8e3] ipe:relative">
      @for (tab of tabs; track tab.value) {
        @let isActive = active === tab.value;
        <button
          type="button"
          class="
            ipe:cursor-pointer
            ipe:relative
            ipe:pb-3
            ipe:text-sm
            ipe:tracking-[0.2em]

            ipe:transition-colors
            ipe:duration-200
          "
          [ngClass]="isActive
            ? 'ipe:font-medium ipe:text-black'
            : 'ipe:font-small ipe:text-gray-400 ipe:hover:text-gray-600'
          "
          (click)="change.emit(tab.value)"
        >
          {{ tab.label }}

          @if (isActive) {
            <span class="ipe:absolute ipe:bottom-0 ipe:left-0 ipe:w-full ipe:h-[2px] ipe:bg-black"></span>
          }
        </button>
      }
    </div>
  `
})
export class GroupingTabsComponent {
  @Input({ required: true }) active!: 'macro' | 'material';
  @Output() change = new EventEmitter<'macro' | 'material'>();

  tabs = [
    { value: 'material' as const, label: 'Materiale' },
    { value: 'macro' as const, label: 'Macro - colore' }
  ];
}
